import { render, staticRenderFns } from "./browsing_history.vue?vue&type=template&id=4c2beee7&scoped=true"
import script from "./browsing_history.vue?vue&type=script&lang=js"
export * from "./browsing_history.vue?vue&type=script&lang=js"
import style0 from "./browsing_history.vue?vue&type=style&index=0&id=4c2beee7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2beee7",
  null
  
)

export default component.exports